﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';


var HelperEvent = {
    getStyleSheet: function (unique_title) {
        for (var i = 0; i < document.styleSheets.length; i++) {
            var sheet = document.styleSheets[i];
            if (sheet.title == unique_title) {
                return sheet;
            }
        }
    },
    getRuleIndex: function (style, className) {
        var ret = -1;

        for (var i = 0; i < style.cssRules.length; i++) {
            var cssRule = style.cssRules[i].selectorText;
            if (style.cssRules[i].selectorText == className) {
                ret = i;
            }
        }

        return ret;
    },
    setBackGroundColor: function (app) {
        switch (app.entities.models.InfoPageSetting.attributes.BackGroundColorType) {
            case "1":
                $('#main-region').css('background-color', app.entities.models.InfoPageSetting.attributes.BackGroundColor);
                $('#app-container').css('background-color', app.entities.models.InfoPageSetting.attributes.BackGroundColor);
                $('body').css('background-color', app.entities.models.InfoPageSetting.attributes.BackGroundColor);
                break;
            case "0":
                $('#main-region').css('background-color', app.entities.models.InfoPageSetting.attributes.BackGroundColorApp);
                $('#app-container').css('background-color', app.entities.models.InfoPageSetting.attributes.BackGroundColorApp);
                $('body').css('background-color', app.entities.models.InfoPageSetting.attributes.BackGroundColorApp);
                break;
        }
    },
    setupCssStyle: function (app) {
        var style = this.getStyleSheet('infopage');
        var cssRulesIdx = this.getRuleIndex(style, '.infopage > h1');
        if (cssRulesIdx != -1) {
            style.deleteRule(cssRulesIdx);

            var font1_style = app.entities.collections.FontStyle.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font1_Style
            });

            var font1_color = app.entities.models.InfoPageSetting.attributes.Font1_Color;

            var font1_lineHeight = app.entities.collections.LineHeight.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font1_LineHeight
            });

            var font1 = app.entities.models.InfoPageSetting.attributes.Font1;

            var rule = String.format(".infopage > h1 {font-family:{0} !important;font-size:{1} !important;color:{2} !important;{3};{4} }",
                font1,
                app.entities.models.InfoPageSetting.attributes.Font1_Size,
                font1_color,
                font1_lineHeight[0].attributes.Style,
                "");
            style.insertRule(rule);
        }
        var cssRulesIdx = this.getRuleIndex(style, '.infopage > h2');
        if (cssRulesIdx != -1) {
            style.deleteRule(cssRulesIdx);

            var font1_style = app.entities.collections.FontStyle.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font1_Style
            });

            var font1_color = app.entities.models.InfoPageSetting.attributes.Font1_Color;

            var font1_lineHeight = app.entities.collections.LineHeight.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font1_LineHeight
            });

            var font1 = app.entities.models.InfoPageSetting.attributes.Font1;

            var rule = String.format(".infopage > h2 {font-family:{0} !important;font-size:{1} !important;color:{2} !important;{3};{4} }",
                font1,
                app.entities.models.InfoPageSetting.attributes.Font1_Size,
                font1_color,
                font1_lineHeight[0].attributes.Style,
                ""/*font1_style[0].attributes.Style*/);
            style.insertRule(rule);
        }
        var cssRulesIdx = this.getRuleIndex(style, '.infopage > h3');
        if (cssRulesIdx != -1) {
            style.deleteRule(cssRulesIdx);

            var font1_style = app.entities.collections.FontStyle.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font1_Style
            });

            var font1_color = app.entities.models.InfoPageSetting.attributes.Font1_Color;

            var font1_lineHeight = app.entities.collections.LineHeight.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font1_LineHeight
            });

            var font1 = app.entities.models.InfoPageSetting.attributes.Font1;

            var rule = String.format(".infopage > h3 {font-family:{0} !important;font-size:{1} !important;color:{2} !important;{3};{4} }",
                font1,
                app.entities.models.InfoPageSetting.attributes.Font1_Size,
                font1_color,
                font1_lineHeight[0].attributes.Style,
                "");
            style.insertRule(rule);
        }
        var cssRulesIdx = this.getRuleIndex(style, '.infopage > h4');
        if (cssRulesIdx != -1) {
            style.deleteRule(cssRulesIdx);

            var font1_style = app.entities.collections.FontStyle.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font1_Style
            });

            var font1_color = app.entities.models.InfoPageSetting.attributes.Font1_Color;

            var font1_lineHeight = app.entities.collections.LineHeight.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font1_LineHeight
            });

            var font1 = app.entities.models.InfoPageSetting.attributes.Font1;

            var rule = String.format(".infopage > h4 {font-family:{0} !important;font-size:{1} !important;color:{2} !important;{3};{4} }",
                font1,
                app.entities.models.InfoPageSetting.attributes.Font1_Size,
                font1_color,
                font1_lineHeight[0].attributes.Style,
                "");
            style.insertRule(rule);
        }
        var cssRulesIdx = this.getRuleIndex(style, '.infopage > h5');
        if (cssRulesIdx != -1) {
            style.deleteRule(cssRulesIdx);

            var font1_style = app.entities.collections.FontStyle.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font1_Style
            });

            var font1_color = app.entities.models.InfoPageSetting.attributes.Font1_Color;

            var font1_lineHeight = app.entities.collections.LineHeight.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font1_LineHeight
            });

            var font1 = app.entities.models.InfoPageSetting.attributes.Font1;

            var rule = String.format(".infopage > h5 {font-family:{0} !important;font-size:{1} !important;color:{2} !important;{3};{4} }",
                font1,
                app.entities.models.InfoPageSetting.attributes.Font1_Size,
                font1_color,
                font1_lineHeight[0].attributes.Style,
                "");
            style.insertRule(rule);
        }
        var cssRulesIdx = this.getRuleIndex(style, '.infopage > h6');
        if (cssRulesIdx != -1) {
            style.deleteRule(cssRulesIdx);

            var font1_style = app.entities.collections.FontStyle.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font1_Style
            });

            var font1_color = app.entities.models.InfoPageSetting.attributes.Font1_Color;

            var font1_lineHeight = app.entities.collections.LineHeight.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font1_LineHeight
            });

            var font1 = app.entities.models.InfoPageSetting.attributes.Font1;

            var rule = String.format(".infopage > h6 {font-family:{0} !important;font-size:{1} !important;color:{2} !important;{3};{4} }",
                font1,
                app.entities.models.InfoPageSetting.attributes.Font1_Size,
                font1_color,
                font1_lineHeight[0].attributes.Style,
                ""/*font1_style[0].attributes.Style*/);
            style.insertRule(rule);
        }
        var cssRulesIdx = this.getRuleIndex(style, '.infopage > p');
        if (cssRulesIdx != -1) {
            style.deleteRule(cssRulesIdx);

            var font2_style = app.entities.collections.FontStyle.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font2_Style
            });

            var font2_color = app.entities.models.InfoPageSetting.attributes.Font2_Color;

            var font2_lineHeight = app.entities.collections.LineHeight.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font2_LineHeight
            });

            var font2 = app.entities.models.InfoPageSetting.attributes.Font2;

            var rule = String.format(".infopage > p {font-family:{0} !important;font-size:{1} !important;color:{2} !important;{3};{4} }",
                font2,
                app.entities.models.InfoPageSetting.attributes.Font2_Size,
                font2_color,
                font2_lineHeight[0].attributes.Style,
                "");
            style.insertRule(rule);
        }

        var cssRulesIdx = this.getRuleIndex(style, '.infopage > p > i');
        if (cssRulesIdx != -1) {
            style.deleteRule(cssRulesIdx);

            var font2_style = app.entities.collections.FontStyle.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font2_Style
            });

            var font2_color = app.entities.models.InfoPageSetting.attributes.Font2_Color;

            var font2_lineHeight = app.entities.collections.LineHeight.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font2_LineHeight
            });

            var font2 = app.entities.models.InfoPageSetting.attributes.Font2;

            var rule = String.format(".infopage > p > i {font-family:{0} !important;font-size:{1} !important;color:{2} !important;{3};{4} }",
                font2,
                app.entities.models.InfoPageSetting.attributes.Font2_Size,
                font2_color,
                font2_lineHeight[0].attributes.Style,
                "");
            style.insertRule(rule);
        }

        var cssRulesIdx = this.getRuleIndex(style, '.infopage > i');
        if (cssRulesIdx != -1) {
            style.deleteRule(cssRulesIdx);

            var font2_style = app.entities.collections.FontStyle.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font2_Style
            });

            var font2_color = app.entities.models.InfoPageSetting.attributes.Font2_Color;

            var font2_lineHeight = app.entities.collections.LineHeight.where({
                Value: app.entities.models.InfoPageSetting.attributes.Font2_LineHeight
            });

            var font2 = app.entities.models.InfoPageSetting.attributes.Font2;

            var rule = String.format(".infopage > i {font-family:{0} !important;font-size:{1} !important;color:{2} !important;{3};{4} }",
                font2,
                app.entities.models.InfoPageSetting.attributes.Font2_Size,
                font2_color,
                font2_lineHeight[0].attributes.Style,
                ""/*font2_style[0].attributes.Style*/);
            style.insertRule(rule);
        }
    },
    setupCssStyle2: function (app) {
        var style = this.getStyleSheet('infopage');
        //New
        var cssRulesIdx = this.getRuleIndex(style, '.e4us_maincolor');
        if (cssRulesIdx != -1) {
            style.deleteRule(cssRulesIdx);
        }

        if (app.entities.models.InfoPageSetting.attributes.MenuColorApp_BackGroundType == "1")
            var bgcolor = app.entities.models.InfoPageSetting.attributes.MenuColor_BackGround;
        else
            var bgcolor = app.entities.models.InfoPageSetting.attributes.MenuColorApp_BackGround;

        var rule = String.format(".e4us_maincolor{background-color: {0}; color: rgba(0, 0, 0, 0.9)!important;}", bgcolor);
        //app.entities.models.InfoPageSetting.attributes.MenuColorApp_BackGround);
            
        style.insertRule(rule);

        //var rule = String.format(".e4us_menucolor01{color: {0}!important;}",
        //    app.entities.models.InfoPageSetting.attributes.MenuColorApp_ForeGround);
        //style.insertRule(rule);

        //var rule = String.format(".e4us_menucolor02{color: {0}!important;}",
        //    app.entities.models.InfoPageSetting.attributes.MenuColorApp_ForeGround02);
        //style.insertRule(rule);
        //var rule = String.format(".navbar-light .navbar-nav .nav-link > a {color: {0}!important;}",
        //    app.entities.models.InfoPageSetting.attributes.MenuColorApp_ForeGround02);
        //style.insertRule(rule);

        //$('.e4us_menucolor02').css('color', app.entities.models.InfoPageSetting.attributes.MenuColorApp_ForeGround02);

        //var rule = String.format(".e4us_menucolor03{color: {0}!important;}",
        //    app.entities.models.InfoPageSetting.attributes.MenuColorApp_ForeGround03);
        //style.insertRule(rule);
        
    },
    setupCssStyle3: function (app) {
        if (app.entities.models.InfoPageSetting.attributes.MenuColorApp_ForeGroundType == "1")
            var rgb = this.rgb2rgb(app.entities.models.InfoPageSetting.attributes.MenuColor_ForeGround);
        else 
            var rgb = this.rgb2rgb(app.entities.models.InfoPageSetting.attributes.MenuColorApp_ForeGround);

        var MenuColorApp_ForeGround02 = String.format('rgba({0},{1},{2},0.9', rgb[0], rgb[1], rgb[2]);
        var MenuColorApp_ForeGround03 = String.format('rgba({0},{1},{2},0.7', rgb[0], rgb[1], rgb[2]);

        $('.e4us_navbar-toggler').css('border-color', app.entities.models.InfoPageSetting.attributes.MenuColorApp_ForeGround);
        var s = String.format("data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='{0}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e", app.entities.models.InfoPageSetting.attributes.MenuColorApp_ForeGround);
        $('.e4us_navbar-toggler-icon').css('background-image', String.format('url("{0}"', s));

        if (app.entities.models.InfoPageSetting.attributes.MenuColorApp_ForeGroundType == "1")
            $('.e4us_maincolor02').css('color', app.entities.models.InfoPageSetting.attributes.MenuColor_ForeGround);
        else
            $('.e4us_maincolor02').css('color', app.entities.models.InfoPageSetting.attributes.MenuColorApp_ForeGround);

        if (app.entities.models.InfoPageSetting.attributes.MenuColorApp_FontType == "0")
            $('.e4us_maincolor02').css('font-family', app.entities.models.InfoPageSetting.attributes.MenuColorApp_Font);
        else
            $('.e4us_maincolor02').css('font-family', app.entities.models.InfoPageSetting.attributes.MenuColor_Font);

        $('.e4us_maincolor02').css('font-size', app.entities.models.InfoPageSetting.attributes.MenuColorApp_FontSize_Header01);

        $('.e4us_menucolor02').css('color', MenuColorApp_ForeGround03);

        if (app.entities.models.InfoPageSetting.attributes.MenuColorApp_FontType == "0")
            $('.e4us_menucolor02').css('font-family', app.entities.models.InfoPageSetting.attributes.MenuColorApp_Font);
        else 
            $('.e4us_menucolor02').css('font-family', app.entities.models.InfoPageSetting.attributes.MenuColor_Font);


        $('.e4us_menucolor02').css('font-size', app.entities.models.InfoPageSetting.attributes.MenuColorApp_FontSize_Header02);

        if (app.entities.models.InfoPageSetting.attributes.MenuColorApp_BackGroundType == "1")
            $('.e4us_menucolor02').css('background-color', app.entities.models.InfoPageSetting.attributes.MenuColor_BackGround);
        else
            $('.e4us_menucolor02').css('background-color', app.entities.models.InfoPageSetting.attributes.MenuColorApp_BackGround);

        if (app.entities.models.InfoPageSetting.attributes.MenuColorApp_ForeGroundType == "1")
            $('.e4us_menucolor01').css('color', app.entities.models.InfoPageSetting.attributes.MenuColor_ForeGround);
        else
            $('.e4us_menucolor01').css('color', app.entities.models.InfoPageSetting.attributes.MenuColorApp_ForeGround);
        //$('.e4us_menucolor01').css('font-family', app.entities.models.InfoPageSetting.attributes.MenuColorApp_Font);
        $('.e4us_menucolor01').css('font-size', app.entities.models.InfoPageSetting.attributes.MenuColorApp_FontSize_Footer);

        $('.e4us_menucolor03').css('color', MenuColorApp_ForeGround02);

        if (app.entities.models.InfoPageSetting.attributes.MenuColorApp_FontType == "0")
            $('.e4us_menucolor03').css('font-family', app.entities.models.InfoPageSetting.attributes.MenuColorApp_Font);
        else 
            $('.e4us_menucolor03').css('font-family', app.entities.models.InfoPageSetting.attributes.MenuColor_Font);

        $('.e4us_menucolor03').css('font-size', app.entities.models.InfoPageSetting.attributes.MenuColorApp_FontSize_Footer);

        $('.e4us_menucolor04').css('color', MenuColorApp_ForeGround02);

        if (app.entities.models.InfoPageSetting.attributes.MenuColorApp_FontType == "0")
            $('.e4us_menucolor04').css('font-family', app.entities.models.InfoPageSetting.attributes.MenuColorApp_Font);
        else
            $('.e4us_menucolor04').css('font-family', app.entities.models.InfoPageSetting.attributes.MenuColor_Font);


        $('.e4us_menucolor04').css('font-size', app.entities.models.InfoPageSetting.attributes.MenuColorApp_FontSize_Footer);
    },
    setupCssStyle4: function (app) {
        var font2_style = app.entities.collections.FontStyle.where({
            Value: app.entities.models.InfoPageSetting.attributes.Font2_Style
        });

        var font2_lineHeight = app.entities.collections.LineHeight.where({
            Value: app.entities.models.InfoPageSetting.attributes.Font2_LineHeight
        });
        
        $('.is-btn.is-btn-ghost1.is-upper.is-btn-small').css('font-family', app.entities.models.InfoPageSetting.attributes.Font2);
        $('.is-btn.is-btn-ghost1.is-upper.is-btn-small span:first-child').css('font-family', app.entities.models.InfoPageSetting.attributes.Font2);
        $('.is-btn.is-btn-ghost1.is-upper.is-btn-small').css('color', app.entities.models.InfoPageSetting.attributes.Font2_Color);
        $('.is-btn.is-btn-ghost1.is-upper.is-btn-small span:first-child').css('color', app.entities.models.InfoPageSetting.attributes.Font2_Color);
        $('.is-btn.is-btn-ghost1.is-upper.is-btn-small').css('font-style', font2_lineHeight[0].attributes.Style);
        $('.is-btn.is-btn-ghost1.is-upper.is-btn-small span:first-child').css('font-style', font2_lineHeight[0].attributes.Style);

        $('.e4us_maincolor.page-link').css('font-family', app.entities.models.InfoPageSetting.attributes.Font2);
        //$('.e4us_maincolor.page-link').css('color', app.entities.models.InfoPageSetting.attributes.MenuColorApp_ForeGround+ ' !important');
        $('.e4us_maincolor.page-link').cssImportant('color', app.entities.models.InfoPageSetting.attributes.MenuColorApp_ForeGround);

        $('.form-control.input-sm').css('font-family', app.entities.models.InfoPageSetting.attributes.Font2);
        $('.form-control.input-sm').css('color', app.entities.models.InfoPageSetting.attributes.Font2_Color);
        $('.dataTables_filter label:first-child').css('font-family', app.entities.models.InfoPageSetting.attributes.Font2);
        $('.dataTables_filter label:first-child').css('color', app.entities.models.InfoPageSetting.attributes.Font2_Color);
        $('.dataTables_length label:first-child').css('font-family', app.entities.models.InfoPageSetting.attributes.Font2);
        $('.dataTables_length label:first-child').css('color', app.entities.models.InfoPageSetting.attributes.Font2_Color);
        $('.dataTables_length label:first-child').css('margin-left', '7px');
        $('.dataTables_length label:first-child').css('margin-right', '7px');

        $('.dataTables_length label:first-child').find("select").css('font-family', app.entities.models.InfoPageSetting.attributes.Font2);
        $('.dataTables_length label:first-child').find("select").css('color', app.entities.models.InfoPageSetting.attributes.Font2_Color);
        $('.dataTables_length label:first-child').find("select").css('margin-left', '7px');

        $('.dataTables_length label:first-child').find("select").find('option').each(function (index, element) {
            $(element).css('font-family', app.entities.models.InfoPageSetting.attributes.Font2);
            $(element).css('color', app.entities.models.InfoPageSetting.attributes.Font2_Color);
        });
        
    },
    rgb2rgb: function (/*rgb,*/ rgb) {
        var inParts = rgb.substring(rgb.indexOf("(")).split(","),
            r = parseInt(this.trim(inParts[0].substring(1)), 10),
            g = parseInt(this.trim(inParts[1]), 10),
            b = parseInt(this.trim(inParts[2]), 10)
        var outParts = [
            r,
            g,
            b
        ];

        // Pad single-digit output values


        return outParts;
    },
    trim: function (str) {
        return str.replace(/^\s+|\s+$/gm, '');
    }
}

export default HelperEvent;